import React from "react";
import {connect} from "react-redux";
import styled from "styled-components";
import {media} from "components/styled";

class Chart extends React.Component {
    constructor() {
        super();
        this.state = {
            parentWidth: 0
        };
        this.ref = React.createRef();
    }

    componentDidMount() {
        this.fitParentContainer();
        window.addEventListener("resize", this.fitParentContainer);
    }

    fitParentContainer = () => {
        const {parentWidth} = this.state;
        
        if (!this.ref.current) return;

        const currentParentWidth =
            this.ref.current && this.ref.current.getBoundingClientRect().width;

        const shouldResize = parentWidth !== currentParentWidth;
        if (shouldResize) {
            this.setState({
                parentWidth: currentParentWidth
            });
        }
    };

    render() {
        const {legendData, selectedLanguage} = this.props;
        const rectColor = ["var(--color-map-1)", "var(--color-map-2)", "var(--color-map-3)", "var(--color-map-4)"];

        const {parentWidth} = this.state;

        const legendWidth = parentWidth * 0.58;
        const rectWidth = legendWidth * 0.25;

        return (
            <div ref={this.ref}>
                <LegendWrapper
                    // innerRef={this.ref}
                    className="legend"
                    lang={selectedLanguage}
                    legendWidth={legendWidth}
                    rectWidth={rectWidth}
                >
                    <ul className="legend-labels">
                        {legendData.map((d, key) => (
                            <li key={key}>
                                <span style={{background: rectColor[key]}}/>
                                {d}
                            </li>
                        ))}
                    </ul>
                </LegendWrapper>
            </div>
        );
    }
}

const LegendWrapper = styled.div`
  margin-bottom: 24px;

  &:after {
    content: "";
    display: table;
    clear: both;
  }

  @media all and (max-width: 600px) {
    width: 100% !important;
    .legend-labels {
      width: 100% !important;
      li {
        width: 25% !important;
        span {
          width: 100% !important;
        }
      }
    }
  }

  ${media.desktop`bottom: 82px`};
  */ ul {
    padding: 0;
    margin: 0;
    float: left;
    list-style: none;
  }
  li {
    display: block;
    float: left;
    width: ${props => `${props.rectWidth}px`};
    text-align: center;
    color: "rgba(255,255,255,0.7)";
    /* font-size: 80%; */
    font-size: ${props => (props.lang === "en" ? "12px" : "13px")};
    list-style: none;
  }
  span {
    display: block;
    float: left;
    height: 15px;
    width: ${props => `${props.rectWidth}px`};
  }
`;

export default connect(state => ({
    selectedLanguage: state.localizationReducers.selectedLanguage
}))(Chart);



// WEBPACK FOOTER //
// ./src/components/visualization/legend/legend.js